import type { RoleModule } from '../types';
/* General Sans — the kit's face. See the nurse module's note. */
import '@/components/kit/fonts.css';
/* Lane-local overrides, gated on `.stock-root` — see the file. */
import './stock.css';
import { StockShelfPage } from './StockShelfPage';
import { StockReceivePage } from './StockReceivePage';
import { StockCatalogPage } from './StockCatalogPage';
import { StockNewItemPage } from './StockNewItemPage';
import { StockOrdersPage } from './StockOrdersPage';
import { StockCountPage } from './StockCountPage';
import { StockTransfersPage } from './StockTransfersPage';

/**
 * The stock-manager surface's routes and door overrides. See ../types.ts.
 * Every route path here must start with `/stock-manager/`.
 *
 * Seven doors in the design; six are open. The shelf (f1) reads what is
 * there, Receive (f4/f4b) is the only way anything gets onto it, the Catalog
 * (f2/f2b/f3) is where an item has to exist before either can happen, Orders
 * (f5–f5d) is how it is bought, Count (f6–f6b) is how the number is checked
 * against the boxes, and Transfers (f7–f7c) moves them between branches. Only
 * the Directory is still closed, and it belongs to its own lane. The rail
 * draws only the doors that resolve to a route, so a closed one stays closed
 * rather than answering with an empty page.
 */
const stock_manager: RoleModule = {
  routes: [
    { path: '/stock-manager/shelf', element: <StockShelfPage /> },
    { path: '/stock-manager/receive', element: <StockReceivePage /> },
    { path: '/stock-manager/catalog', element: <StockCatalogPage /> },
    { path: '/stock-manager/catalog/new', element: <StockNewItemPage /> },
    { path: '/stock-manager/orders', element: <StockOrdersPage /> },
    { path: '/stock-manager/count', element: <StockCountPage /> },
    { path: '/stock-manager/transfers', element: <StockTransfersPage /> },
  ],
  doorRoutes: {
    stock: '/stock-manager/shelf',
    receive: '/stock-manager/receive',
    catalog: '/stock-manager/catalog',
    orders: '/stock-manager/orders',
    count: '/stock-manager/count',
    transfers: '/stock-manager/transfers',
  },
};

export default stock_manager;
